<template>
    <div>
        <div v-show="!loading || showContent">
            <slot></slot>
        </div>
        <div v-show="loading" :class="{ fixed: showContent }">
            <slot name="label"></slot>
            <ring-loader :size="size" :loading="loading" />
        </div>
    </div>
</template>

<script>
import RingLoader from 'vue-spinner/src/RingLoader.vue'

export default {
  name: 'ViewLoader',
  components: { RingLoader },
  props: {
    loading:{
      type: Boolean,
      default: false,
    },
    showContent: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: '60px'
    }
  },
}
</script>

<style scoped>
.fixed {
    position: fixed;
    left: 50%;
    top: 45%;
}
</style>
